enum BiteLogVerifoneCommanderEvent {
  StateChanged = 1,
  TokenInitialized = 2,
  TokenInitializeFailed = 3,
  RefreshSessionSuccess = 4,
  RefreshSessionFailed = 5,
  BeginSessionSuccess = 6,
  BeginSessionFailed = 7,
  UploadTokenSuccess = 8,
  UploadTokenFailed = 9,
  ConnectWebSocketSuccess = 10,
  ConnectWebSocketFailed = 11,
  OpenCashierSuccess = 12,
  OpenCashierFailed = 13,
  FetchMenuSuccess = 14,
  FetchMenuFailed = 15,
  UploadMenuSuccess = 16,
  UploadMenuFailed = 17,
  PostTransactionSuccess = 18,
  PostTransactionFailed = 19,
  SessionExpired = 20,
  SessionRecoveryFailed = 21,
  CheckBiteMenuSuccess = 22,
  CheckBiteMenuFailed = 23,
  NativePingFailed = 24,
  NativePingSuccess = 25,
  RecoverFromDisconnectionFailed = 26,
  CloseCashierSuccess = 27,
  CloseCashierFailed = 28,
  EndSessionSuccess = 29,
  EndSessionFailed = 30,
  // Business failures: HTTP-200 responses with <failure reason="..."> that are NOT
  // session-expired (those flow through *Failed via CommanderSessionError).
  PostTransactionBusinessFailure = 31,
  BeginSessionBusinessFailure = 32,
  OpenCashierBusinessFailure = 33,
  CloseCashierBusinessFailure = 34,
  EndSessionBusinessFailure = 35,
  FetchMenuBusinessFailure = 36,
  // RefreshSession: HTTP-200 <VFI:Fault> on the validate command (e.g.
  // CGIPortal.InternalError "Invalid Credentials" when the token is not accepted,
  // or CGIPortal.ParseError). Distinct from a generic network/transport failure.
  RefreshSessionBusinessFailure = 37,
}

export { BiteLogVerifoneCommanderEvent };
